module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("UnitAlias", "Change the name of this device") ))==null?'':__t)+
'</legend><div><label for="alias-alias-input">'+
((__t=( i18n.tc("UnitAlias", "Device name:") ))==null?'':__t)+
'</label> <input type="text" id="alias-alias-input" data-input="alias-alias" value="'+
((__t=( alias ))==null?'':__t)+
'" required></div></fieldset><fieldset class="button-wrap"><button data-click="alias-cancel">'+
((__t=( i18n.tc("UnitAlias", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="alias-submit">'+
((__t=( i18n.tc("UnitAlias", "Save") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
